import Vue from 'vue';

Vue.filter('h-integers', (value) => {
  let output = '';
  if (value < 1000) {
    output = value;
  } else if (value > 1000000) {
    output = `${(value / 1000000).toFixed(2).replace(/\.?0+$/, '')}kk`;
  } else if (value >= 1000) {
    output = `${(value / 1000).toFixed(2).replace(/\.?0+$/, '')}k`;
  }
  return output;
});

Vue.filter('h-integers-default', (value) => {
  let output = '';
  if (value === 0) {
    output = '---';
  } else if (value <= 1000) {
    output = value;
  } else if (value > 1000000) {
    output = `${(value / 1000000).toFixed(2).replace(/\.?0+$/, '')}kk`;
  } else if (value > 1000) {
    output = `${(value / 1000).toFixed(2).replace(/\.?0+$/, '')}k`;
  }
  return output;
});
